import React, { useState, useEffect } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import DisplayUser from "../../components/user/DisplayUser";
import TextField from "@material-ui/core/TextField";
import { jobClient } from "../../AxiosClient";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { Virtuoso } from "react-virtuoso";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import classNames from "classnames";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
    detailContainer: {
      display: "flex",
      backgroundColor: theme.palette.grey[300],
    },
    table: {
      margin: 10,
      width: "20%",
    },
    settingsTable: {
      margin: 10,
      flex: 1,
    },
    icon: {
      marginBottom: -8,
      marginRight: -4,
      marginLeft: -7,
    },
    iconSuccess: {
      color: theme.palette.success.main,
    },
    iconError: {
      color: theme.palette.error.main,
    },
    delta: {
      marginLeft: 10,
    },
  }));
  
function KnowledgeSourceDetail(props) {
    const { t } = useTranslation();
    const [jobData, setJobData] = useState(null);
    const [sourceData, setSourceData] = useState(null);
    const [settingsSearch, setSettingsSearch] = useState("");
    const classes = useStyles();
    useEffect(() => {
        getJobData()
    },[props.sourceId])
    
    useEffect(() => {
        setSourceData(props.sourceData)
    },[props.sourceData])

    const getJobData = () => {
        jobClient.get(`/knowledgesource/data/${props.sourceId}`).then((res) => {
          setJobData(res.data)
        });
    }
    const renderSettings = () => {
        let sourceprops = [];
        for (let rp in props.sourceData.properties.readerProperties) {
          let value = props.sourceData.properties.readerProperties[rp];
          if (typeof value === "object" && value !== null) {
            value = JSON.stringify(value);
          } else if (Array.isArray(value)) {
            value = value.join();
          } else {
            value = String(value);
          }
          sourceprops.push({
            key: rp,
            value,
            subsection: "reader",
          });
        }
        for (let srcp in props.sourceData.properties.sourceProperties) {
          let value = props.sourceData.properties.sourceProperties[srcp];
          if (typeof value === "object" && value !== null) {
            value = JSON.stringify(value);
          } else if (Array.isArray(value)) {
            value = value.join();
          } else {
            value = String(value);
          }
          sourceprops.push({
            key: srcp,
            value,
            subsection: "source",
          });
        }
        for (let spip in props.sourceData.properties.spiderProperties) {
          let value = props.sourceData.properties.spiderProperties[spip];
          if (typeof value === "object" && value !== null) {
            value = JSON.stringify(value);
          } else if (Array.isArray(value)) {
            value = value.join();
          } else {
            value = String(value);
          }
          sourceprops.push({
            key: spip,
            value,
            subsection: "spider",
          });
        }
        sourceprops = sourceprops.filter((prop) => {
          return (
            prop.key !== "id" &&
            prop.key !== "redirectURL" &&
            prop.key !== "refreshToken" &&
            prop.key !== "accessToken" &&
            prop.key !== "accessTokenExpiry"
          );
        });
        if (!!props.settingsSearch) {
            sourceprops = sourceprops.filter((prop) => {
            return t(prop.key)
              .toLowerCase()
              .includes(props.settingsSearch.toLowerCase());
          });
        }
        return (
          <Virtuoso
            totalCount={sourceprops.length}
            itemContent={(idx) => {
              return (
                <TableRow component="div" style={{ display: "flex" }}>
                  <TableCell component="div" style={{ flex: 1 }}>
                    {t(sourceprops[idx].key)}
                  </TableCell>
                  <TableCell
                    component="div"
                    style={{ flex: 1, textAlign: "right" }}
                  >
                    {sourceprops[idx].value}
                  </TableCell>
                </TableRow>
              );
            }}
          />
        );
      };
    
      const renderDelta = (now, previous, successIfHigher) => {
        if (now > previous) {
          return (
            <span className={classes.delta}>
              (
              <ArrowDropUpIcon
                className={classNames(classes.icon, {
                  [classes.iconSuccess]: successIfHigher,
                  [classes.iconError]: !successIfHigher,
                })}
              />
              {now - previous})
            </span>
          );
        } else if (previous > now) {
          return (
            <span className={classes.delta}>
              (
              <ArrowDropDownIcon
                className={classNames(classes.icon, {
                  [classes.iconSuccess]: !successIfHigher,
                  [classes.iconError]: successIfHigher,
                })}
              />
              {previous - now})
            </span>
          );
        }
      };
    
    return (
        jobData !== null ? (
        <div className={classes.detailContainer}>
            <TableContainer component={Paper} className={classes.table}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                {t("manage_ks_last_index_stats")}
                            </TableCell>
                            <TableCell align="right" />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell component="th" scope="row">
                                {t("manage_ks_last_indexed")}
                            </TableCell>
                            <TableCell align="right">
                                <>
                                    {jobData.sourceLastReindexed &&
                                        <>{moment(jobData.sourceLastReindexed).format("LLLL")}</>}
                                </>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" scope="row">
                                {t("manage_ks_documents_indexed")}
                            </TableCell>
                            <TableCell align="right">
                                <>
                                    {jobData.lastResult &&
                                        <>{jobData.lastResult.indexed}</>}
                                    {(jobData.lastResult &&
                                        !isNaN(jobData.lastResult.indexed)) &&
                                        (jobData.previousResult &&
                                            !isNaN(jobData.previousResult.indexed)) &&
                                        renderDelta(
                                            jobData.lastResult.indexed,
                                            jobData.previousResult.indexed,
                                            true
                                        )}
                                </>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" scope="row">
                                {t("manage_ks_documents_deleted")}
                            </TableCell>
                            <TableCell align="right">
                                <>
                                    {jobData.lastResult && 
                                        <>{jobData.lastResult.deleted}</> }
                                    {(jobData.lastResult &&
                                        !isNaN(jobData.lastResult.deleted)) &&
                                        (jobData.previousResult &&
                                            !isNaN(jobData.previousResult.deleted)) &&
                                        renderDelta(
                                            jobData.lastResult.deleted,
                                            jobData.previousResult.deleted,
                                            false
                                        )}
                                </>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" scope="row">
                                {t("manage_ks_documents_errored")}
                            </TableCell>
                            <TableCell align="right">
                                <>
                                    {jobData.lastResult &&
                                        <>{jobData.lastResult.errored}</> } 
                                    {(jobData.lastResult &&
                                        !isNaN(jobData.lastResult.errored)) &&
                                        (jobData.previousResult &&
                                            !isNaN(jobData.previousResult.errored)) &&
                                        renderDelta(
                                            jobData.lastResult.errored,
                                            jobData.previousResult.errored,
                                            false
                                        )}
                                </>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <TableContainer
                component={Paper}
                className={classes.settingsTable}
            >
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Knowledge Source Info</TableCell>
                            <TableCell align="right" />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell component="th" scope="row">
                                {t("manage_ks_created_by_table_header")}
                            </TableCell>
                            <TableCell align="right">
                                <DisplayUser userId={sourceData.createdBy} />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" scope="row">
                                {t("manage_ks_date_created_table_header")}
                            </TableCell>
                            <TableCell align="right">
                                {moment(sourceData.dateCreated).format("LLLL")}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" scope="row">
                                {t("manage_ks_last_modified_by_table_header")}
                            </TableCell>
                            <TableCell align="right">
                                <DisplayUser userId={sourceData.modifiedBy} />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" scope="row">
                                {t("manage_ks_last_modified_date_table_header")}
                            </TableCell>
                            <TableCell align="right">
                                {moment(sourceData.dateModified).format("LLLL")}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <Paper className={classes.settingsTable}>
                <div
                    style={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <TableHead component="div">
                        <TableRow component="div" style={{ display: "flex" }}>
                            <TableCell component="div" style={{ flex: 1 }}>
                                Knowledge Source Settings
                            </TableCell>
                            <TableCell component="div">
                                <TextField
                                    placeholder="Search for a setting..."
                                    value={settingsSearch}
                                    onChange={(e) => {
                                        setSettingsSearch(e.target.value);
                                    }}
                                />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <div style={{ flex: 1 }}>{props.sourceData && renderSettings()}</div>
                </div>
            </Paper>
        </div>
        ) : (
            <></>
        )
    )

}
export default KnowledgeSourceDetail